<template>
    <div class="customer-profile registration-customer-form">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                step-style
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <div class="wrap-content customer-section">
                    <div class="filter-section">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>{{ $route.meta.name }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            menuListing: [
                {
                    // anchorLink: '/register-customer/setup-profile',
                    menuLabel: 'Setup Profile',
                    sessionStep: '1',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                // {
                //   // anchorLink: '/register-customer/account-info',
                //   menuLabel: 'Account Info',
                //   sessionStep: '2',
                //   name: 'upload-document',
                //   permission: ['register-customer'],
                // },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Finish',
                    sessionStep: '3',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
            ],
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['form', 'dataSegmentId']),

        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > mounted

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.goToFirstStep()
                this.checkOcrSwitch()
            }
        },
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        this.goToFirstStep()
        this.checkOcrSwitch()
        this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * go to the first step
         *
         * @return {void}
         */
        goToFirstStep() {
            if (
                ![
                    'setup-profile',
                    'public-registration-setup-profile',
                ].includes(this.$route.name)
            ) {
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-setup-profile',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push({
                        name: 'setup-profile',
                    })
                }
            }
        }, // End of goToFirstStep() method

        /**
         * check if the ocr switch configurations
         * is on for this data segment
         *
         * @return {void}
         */
        async checkOcrSwitch() {
            try {
                let { data } = await request({
                    url: `/configurations/ocr/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })

                this.$store.commit('setValue', {
                    key: 'useOcr',
                    value: data.data.switch,
                })

                this.$store.commit('setValue', {
                    key: 'restrictDuplicateCustomers',
                    value: data.data.restrictDuplicateCustomers,
                })
            } catch (error) {
                // console.log(error)
            }
        }, // End of checkOcrSwitch() method
    }, // End of Component > watch
} // End of export default
</script>
